<template>
  <tr class="linha-materia-prima-selecionada" :class="{'text-red': MATERIA_PRIMA.fora_linha}">
    <td>
      <v-icon v-if="MATERIA_PRIMA.fora_linha" color="red" size="16" class="mr-1">mdi-alert</v-icon>
      <span v-text="`${MATERIA_PRIMA.id_produto} - ${MATERIA_PRIMA.descricao}`" />
    </td>

    <td>
      <div class="w-full">
        <InputFormatadorDeValor
          v-model="MATERIA_PRIMA.peso_pa"
          class="input-regular"
          centralizar
          :sufixo="MATERIA_PRIMA.idunidade_medida"
          @focus="$event.target.select()"
        />
      </div>
    </td>

    <td class="text-center">{{ MATERIA_PRIMA.fora_linha ? 'Sim' : 'Não' }}</td>

    <td>
      <v-btn
        v-if="MATERIA_PRIMA.utilizado_por_categoria"
        icon color="#CACACA"
        :title="MATERIA_PRIMA.utilizado_por_categoria ? 'Matéria prima está vinculada a uma categoria de compra, por isso não pode ser excluída.' : ''"
      >
        <v-icon>mdi-delete-forever</v-icon>
      </v-btn>

      <v-btn v-else icon @click="$emit('remover-item', MATERIA_PRIMA)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import InputFormatadorDeValor from "@/components/utils/InputFormatadorDeValor";
export default {
  name: "MateriaPrimaSelecionado",
  components: {InputFormatadorDeValor},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Object
  },
  computed: {
    MATERIA_PRIMA: {
      get() {
        return this.modelValue
      },
      set(valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  },
  created() {
    if (!this.MATERIA_PRIMA.peso_pa) {
      this.MATERIA_PRIMA = {
        ...this.MATERIA_PRIMA,
        peso_pa: 1
      }
    }
  }
}
</script>

<style scoped>
.linha-materia-prima-selecionada td {
  border-top: 1px solid #d7d7d7;
  height: 45px;
}
</style>
